import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";


class FITCodDefiTipProd extends Component {
 
  componentDidMount () {
  
    
  }
  render () {
   //[{year: 2002, value: 10.5}]
    
    return this.props.data.length > 0 ? 
    <div className="table-wrapper has-mobile-cards">
      <table className="table db-trafico is-striped is-hoverable">
        <thead>
          <tr>
            
            <th draggable="false" className="is-sortable is-unselectable is-current-sort">
              <div className="th-wrap"><span className="is-relative">&nbsp;</span></div>
            </th>
            <th draggable="false" className="is-sortable is-unselectable">
              <div className="th-wrap"><span className="is-relative">Código</span></div>
            </th>
            <th draggable="false" className="is-sortable is-unselectable">
              <div className="th-wrap"><span className="is-relative">Definición</span></div>
            </th>
          </tr>
        </thead>
        <tbody>
          { this.props.data.map((item, index) => {
            return <tr key={ index } draggable="false" className="">
              <td className="">{ item.codigo }</td>
              <td className="">{ item.definicion }</td>
          
            </tr>
          }) }
        </tbody>
        
      </table>
      
    </div>
    : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(FITCodDefiTipProd)